const data = {
  headerData: {
    logo: '../images/CoverClap.svg',
    profleIcon: '../images/profileIcon.jpg',
    nav: [
      {
        title: "MONTREAL",
      }
    ]
  },
  zoraData: {
    logo: '../images/Zorastreet.png',
    nav: [
      {
        title: "MONTREAL",
      }
    ]
  },
  headline: "Explore Montreal Stylists",

};


export default data;